export const float = number => (parseFloat(number) || 0).toFixed(2)